export default __webpack_public_path__ + "static/media/SJA1520.34I-42091_-25235_0.fd465fdd.jpg";